<template>
    <header class="recipes--header">
        <div class="recipes--search">
            <form @submit.prevent="redirectToSearchResult">
                <input
                    class="recipes-search--field"
                    type="search"
                    name="search"
                    placeholder="Sök rätt, ingredienser eller kosttyp"
                    autocomplete="off"
                    @keyup="getSearchResult"
                    v-model="query"
                />
                <svg class="icon icon-search">
                    <use xlink:href="#icon-search"></use>
                </svg>
                <a :href="searchResultUrl" class="recipes--search-submit">Sök</a>
            </form>
            <a href="/recept/sok?search=" class="recipes--search-advanced">avancerad sök</a>
        </div>
        <div v-if="query">
            <div class="recipes--quick-search-result">
                <ul class="recipes--result">
                    <li class="recipe" v-for="recipe in recipes" :key="recipe.id">
                        <a :href="`/recept/${recipe.slug}`" class="recipe--featured-image col-sm-2">
                            <span v-if="recipe.plus_members_only" class="recipe--plus-members-only">
                                <svg class="icon icon-plus">
                                    <use xlink:href="#icon-plus"></use>
                                </svg>
                            </span>

                            <span v-if="recipe.is_author_admin" class="recipe--author-admin">M</span>

                            <div :class="recipe.featured_image ? 'recipe--image' : 'recipe--no-image'">
                                <img
                                    class="recipe--img"
                                    :alt="recipe.title"
                                    :src="
                                        recipe.featured_image
                                            ? `/assets/media/thumbnail/recipe/${recipe.featured_image}`
                                            : '/assets/images/static/recipes/default-image-recipe.jpg'
                                    "
                                />
                            </div>
                        </a>

                        <header class="recipe--summary col-sm-8">
                            <div class="recipe--tags" v-if="recipe.tag_titles">
                                <span v-for="tag in recipe.tag_titles" :key="tag.id"> {{ tag }} </span>
                            </div>
                            <h3 class="recipe--title">
                                <a :href="`/recept/${recipe.slug}`">{{ recipe.title }}</a>
                            </h3>
                            <div class="recipe--author">
                                <span v-if="recipe.username">av {{ recipe.username }}</span>
                                <span v-else>av Anonym</span>
                            </div>
                            <div class="recipe--rating" v-if="recipe.rating_avg">
                                <span
                                    class="recipe--rating-result"
                                    :style="{ width: ratingWidth(recipe.rating_avg, 100) + 'px' }"
                                ></span>
                            </div>
                        </header>
                    </li>
                </ul>

                <p v-if="searchMessage && query.length > 3" class="recipes--search-message">
                    {{ searchMessage }}
                </p>
                <a :href="searchResultUrl" class="recipes--show-results col-xs-12" v-if="recipesInfo.total">
                    Visa alla {{ recipesInfo.total }} recept
                </a>
            </div>
        </div>
    </header>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            recipes: [],
            recipesInfo: {},
            query: '',
            searchMessage: ''
        };
    },

    computed: {
        searchResultUrl() {
            return '/recept/sok?search=' + this.query;
        }
    },

    methods: {
        redirectToSearchResult() {
            window.location.href = this.searchResultUrl;
        },

        ratingWidth(ratingAvg, width) {
            return (ratingAvg / 5) * width;
        },

        getSearchResult() {
            if (this.query.length >= 3) {
                axios
                    .get('/recept/api/filter/4/?search=' + this.query)
                    .then((response) => {
                        this.recipes = response.data.recipes;
                        this.recipesInfo = response.data.recipesInfo;
                        this.searchMessage = response.data.searchMessage;
                    })
                    .catch((error) => {});
            }
        }
    }
};
</script>
